import sLogo from "@/shared/assets/social-match/S_logo.webp"

export function SocialMatchHero() {
	return (
		<div className="relative flex flex-col items-center gap-1">
			<div
				aria-hidden
				className="absolute inset-0 -z-10 scale-[2.2] bg-[radial-gradient(ellipse_at_center,rgba(0,0,0,0.72)_0%,transparent_68%)] blur-xl"
			/>
			<img
				src={sLogo}
				alt=""
				aria-hidden
				className="size-35 object-contain drop-shadow-[0_0_32px_rgba(255,255,255,0.35)]"
			/>
			<p className="bg-linear-to-r from-[#cacaca] via-[#c8c9d0] to-[#8b8b8b] bg-clip-text text-[20px] leading-none font-extrabold text-transparent uppercase">
				Social Match
			</p>
		</div>
	)
}
